import React from "react";

const ErrorText = (props) => {
  const { children, className } = props;
  return (
    <div className={`container ${className}`}>
      <div className="notification content is-danger">
        <span className="material-icons info">error</span>
        {children}
      </div>
    </div>
  );
};

export default ErrorText;